import React, { Component } from 'react';
import { SelectField } from 'react-md';

export default class SettingsTopBar extends Component {

    constructor(props) {
        super(props);

        this.defaultProps = {}

        this.state = {

        }

        this.handleBack = this.handleBack.bind(this);
        this.showTargetTutorial = this.showTargetTutorial.bind(this);
    }

    componentDidMount() {

    }

    componentWillReceiveProps() {

    }

    componentWillUnmount() {

    }

    handleBack() {
        this.props.handleModeChange('home');
    }

    showTargetTutorial() {

        let messageData = [
            {
                type: 'h1',
                text: "Targets"
            }, {
                type: 'h2',
                text: "What are Targets?"
            }, {
                type: 'p',
                text: "Targets are generalized goals for your business. "
            }, {
                type: 'h2',
                text: "General Progress"
            }, {
                type: 'p',
                text: "The first step in setting up targets is to declare a general progress percentage. Think of this saying, \"I want to generally " +
                    "do X% better than last year.\""
            }, {
                type: 'h2',
                text: "Location and Employee Metrics"
            }, {
                type: 'p',
                text: "Targets are split into location and employee metrics, and those metric settings are accessed by clicking the coresponding icons."
            }, {
                type: 'h2',
                text: "Daily Minimums vs Percentages"
            }, {
                type: 'p',
                text: "For each metric listed, there are two fields labeled '#' and '%'. The '%' field represents a percentage over or under last year's value. " +
                    "The '#' field represents a daily minimum value, and is mostly used for instances where there is no data for last year (e.g. a new store opening). " +
                    "In the metrics page, whichever number is better for your business will be used."
            }, {
                type: 'h2',
                text: "Drilling In"
            }, {
                type: 'p',
                text: "If you click on the name of a metric, you'll be greeted by a list of locations. This allows you to fine tune the selected metric by location. " +
                    "In other words, if I want my Total Sales to generally be 10% better, but I know Store C has more potential, I can set the Total Sales target for " +
                    "that store to 12%."
            }, {
                type: 'h2',
                text: "How Many Days in a Week?"
            }, {
                type: 'p',
                text: "Daily minimums can be extrapolated to give a rough estimate of other time periods such as weekly, monthly, or yearly minimums. To better estimate " +
                    "what those numbers might be, ZeeZor needs to know the number of days each location is open each week. To set this up, click the calendar icon in the " +
                    "top right corner. From there, use the top row to set the days open for all locations at once."
            }, {
                type: 'h2',
                text: "Saving Changes"
            }, {
                type: 'p',
                text: "After every change, your targets are automatically saved so no further action is needed!"
            }
        ];

        alert(messageData.reduce((r, e) => {
            r.push((<div className={"alert " + e.type}>{e.text}</div>)); return r;
        }, []));
    }

    render() {
        let outerStyle = {};
        if (!this.props.isScrollTop) {
            outerStyle.boxShadow = '0 1px 2px rgba(0, 0, 0, 0.16), 0 3px 3px rgba(0, 0, 0, 0.23)';
        }

        let backJsx = (<div className="settings-top-bar-menu-button"></div>);
        if (this.props.mode === 'home' || this.props.mode === undefined) {
            backJsx = (<div className="settings-top-bar-menu-button material-icons" onClick={this.props.toggleNav}>menu</div>);
        } else if (this.props.mode === 'info' || this.props.mode === 'results') {
            backJsx = (<div className="settings-top-bar-menu-button material-icons" onClick={this.handleBack}>arrow_back</div>);
        }

        let rightJsx = null;
        if (this.props.links[this.props.activeIndex].label === 'Targets') {
            //rightJsx = (<div className="settings-top-bar-menu-button material-icons" onClick={this.showTargetTutorial}>info</div>);
        }

        return (
            <div className="settings-top-bar-outer" style={outerStyle}>
                {backJsx}
                <div className="settings-top-bar-title-container">Engage</div>
                {rightJsx}
            </div>
        );
    }
}
